import React from "react";
import QuickLinksTile from "../../common/QuickLinksTile";
import Tile from "../../common/Tile";
import StaffListComponent from "../StaffList/StaffListComponent";
import { Constants } from "../../../constants/constants";
import { NavigateFunction } from "react-router";
import { StaffCountData } from "./Dashboard";
import LoaderPopupModel from "../../common/LoaderPopup";
import { resetUserRegistrationNewpayload } from "../../../store/slices/userOnboardSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store/store";
import { useTranslation } from "react-i18next";
import { readFromLocalStorage } from "../../../utils/DataEncryption";

export interface DashboardWebComponentProps {
  staffCount: StaffCountData | null;
  handleTileClick: (key: string) => void;
  TitleMap: Record<any, any>;
  quickLinksData: { title: string; description: string; link: string }[];
  navigate: NavigateFunction;
  isLoading: boolean;
}

const DashboardWebComponent: React.FC<DashboardWebComponentProps> = ({
  staffCount,
  handleTileClick,
  TitleMap,
  quickLinksData,
  navigate,
  isLoading,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { t, i18n } = useTranslation();
  const application = JSON.parse(readFromLocalStorage("applications") || '""');

  return (
    <div className="bg-dashboardBackgroundColor  pb-10">
      {isLoading && <LoaderPopupModel isOpen={isLoading} />}
      <div className="title1 ml-6 mt-4 text-blackColor font-poppins">
        {t("overview")}
      </div>
      <div className="flex">
        <div className="flex flex-wrap w-full mr-6 justify-around">
          {staffCount &&
            Object.entries(staffCount)
              .filter(([key]) => key !== "passiveStaff") // 👈 filter out passiveStaff
              .map(([key, value]) => (
                <div
                  data-testid="dashboard-tile"
                  key={key}
                  className="cursor-pointer w-1/4"
                  onClick={() => handleTileClick(key)}
                >
                  <Tile title={TitleMap[key]} count={value} />
                </div>
              ))}
        </div>
      </div>

      <div className="title1 ml-6 mt-6 text-blackColor font-poppins">
        {t("quickLinks")}
      </div>
      <div className=" flex  ">
        <div
          className={`flex flex-wrap w-full mr-6 ${
            Array.isArray(application) &&
            application.some(
              (app) => !["salesmate-app", "salesmate-asa-app"].includes(app)
            )
              ? "justify-around"
              : ""
          }`}
        >
          {Object.entries(quickLinksData).map(([key, value]) => (
            <div
              data-testid="quick-link-tile"
              className="cursor-pointer w-1/2"
              onClick={() => {
                dispatch(resetUserRegistrationNewpayload());
                navigate(value.link);
              }}
            >
              <QuickLinksTile
                title={value.title}
                description={value.description}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="px-6 pt-6">
        <StaffListComponent />
      </div>
    </div>
  );
};

export default DashboardWebComponent;
